// extracted by mini-css-extract-plugin
export var phone = "_3h-0";
export var phoneDragging = "_3h-1";